<template>
  <ul>
    <li v-for="c in categories" :key="c.id">
      <router-link :to="{ path: '/shop', query: { web_category: String(c.id) } }">
        {{ c.name }}
        <i v-if="c.children && c.children.length" class="fas fa-angle-down"></i>
      </router-link>
      <ul class="submenu" v-if="c.children && c.children.length">
        <li v-for="child in c.children" :key="`${c.id}-${child.id}`">
          <router-link
            v-if="child.type === 'category'"
            :to="{ path: '/shop', query: { web_category: String(c.id), category: String(child.id) } }"
          >{{ child.name }}</router-link>
          <router-link
            v-else-if="child.type === 'sub_category'"
            :to="{ path: '/shop', query: { web_category: String(c.id), category_child: String(child.id) } }"
          >{{ child.name }}</router-link>
          <router-link
            v-else
            :to="{ path: '/shop', query: { web_category: String(c.id), brand: String(child.id) } }"
          >{{ child.name }}</router-link>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { formatUrl } from "@/utils/utils";

export default {
  name: "HeaderCategory",
  props: {
    categories: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    formatUrl
  }
};
</script>
